import styled from "styled-components";
import { colors } from "theme";
import { Ptag } from "./core/fonts";

export const DisplayBox = ({ value, label }) => {
  return (
    <>
      <Ptag fontSize="14px" fontWeight="500" marginBottom="-5px">
        {label}
      </Ptag>
      <DisplayBoxStyle value={value} label={label}>
        {value}
      </DisplayBoxStyle>
    </>
  );
};

const DisplayBoxStyle = styled.div`
  height: ${({ label }) => label === "Gross Premium" ? "50px" : "12.5px"};
  padding: 0 ${({ label }) => label === "Gross Premium" ? "12.5px" : "0"};
  border: 1px solid ${colors.primaryColor};
  border-radius: 10px;
  font-size: 14px !important;
  color: #009999;
  display: flex;
  align-items: center;
`;


